import { render, staticRenderFns } from "./ANewProfesion.vue?vue&type=template&id=c9e18b4a"
import script from "./ANewProfesion.vue?vue&type=script&lang=js"
export * from "./ANewProfesion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports